import UserComplaintContent from "./UserComplaintContent";

export default UserComplaintContent;